import React from 'react';
import { SectionKey, SectionProps } from './sectionRegistry';
import {
  GroupsSection,
  KeywordsSection,
  AppointmentTypeSection,
  ContactDateSection,
  RecurringSettingsSection,
  TextToWinSettingsSection,
  EnrollmentWindowSection,
} from '../components/sections';

/**
 * Maps each SectionKey to its presentational component.
 * Kept separate from sectionRegistry.ts so the registry data stays
 * importable without pulling in React component code.
 */
export const SECTION_COMPONENTS: Record<SectionKey, React.FC<SectionProps>> = {
  groups: GroupsSection,
  keywords: KeywordsSection,
  appointmentType: AppointmentTypeSection,
  contactDate: ContactDateSection,
  recurringSettings: RecurringSettingsSection,
  textToWinSettings: TextToWinSettingsSection,
  enrollmentWindow: EnrollmentWindowSection,
};
